// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".market-tabs[data-v-573b5fee]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;gap:30px;width:100%}.market-tabs .tab[data-v-573b5fee]{border-bottom:1px solid #333;cursor:pointer;font-size:18px;padding:5px;text-align:center;width:100%}.market-tabs .tab.active[data-v-573b5fee]{border-bottom:1px solid var(--main-green)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
